export enum EmployeeState {
  Accepted = "Accepted",
  Pending = "Pending",
  TriedButFailed = "TriedButFailed",
  EnrollmentInProcess = "EnrollmentInProcess",
  EnrollmentInQueue = "EnrollmentInQueue",
  PayrollEnrolled = "PayrollEnrolled",
  KYCDataCompleted = "KYCDataCompleted",
  KYCDataPending = "KYCDataPending",
  KYCFailed = "KYCFailed",
  AdditionalDataCompleted = "Completed",
  PendingWithHR = "PendingWithHR",
  ReadyForAccountOpening = "ReadyForAccountOpening",
  AccountOpened = "AccountOpened",
  AccountRejected = "AccountRejected",
}

export const ENROLLED_STATUSES: EmployeeState[] = [
  EmployeeState.Accepted,
  EmployeeState.KYCDataPending,
  EmployeeState.KYCDataCompleted,
  EmployeeState.AccountOpened,
  EmployeeState.AdditionalDataCompleted,
];

export const isEnrolledStatus = (status: string): boolean =>
  ENROLLED_STATUSES.includes(status as EmployeeState);
